export const menuData = [
  {
    id: 1,
    menuFirst: "회사 소개",
    menuLink: "/company/introduction",
    menuSecond: [
      {
        secondLink: "/company/introduction",
        secondName: "회사 비젼",
      },
      {
        secondLink: "/company/history",
        secondName: "회사 연혁",
      },
    ],
  },
  {
    id: 2,
    menuFirst: "예약하기",
    menuLink: "/reservation",
    menuSecond: [],
  },
  {
    id: 3,
    menuFirst: "구단 이동",
    menuLink: "/move",
    menuSecond: [
      {
        secondLink: "/move/samsung",
        secondName: "삼성 라이온즈",
      },
      {
        secondLink: "/move/lotte",
        secondName: "롯데 자이언츠",
      },
      {
        secondLink: "/move/twins",
        secondName: "LG 트윈스",
      },
      {
        secondLink: "/move/kiwoom",
        secondName: "키움 히어로즈",
      },
      {
        secondLink: "/move/kia",
        secondName: "기아 타이거즈",
      },
      {
        secondLink: "/move/nc",
        secondName: "NC 다이노스",
      },
      {
        secondLink: "/move/eagles",
        secondName: "한화 이글스",
      },
      {
        secondLink: "/move/ssg",
        secondName: "SSG 랜더스",
      },
      {
        secondLink: "/move/kt",
        secondName: "KT WIZ",
      },
      {
        secondLink: "/move/doosan",
        secondName: "두산 베어스",
      },
    ],
  },
  {
    id: 4,
    menuFirst: "구독하기",
    menuLink: "/sub",
    menuSecond: [],
  },
  {
    id: 5,
    menuFirst: "커뮤니티",
    menuLink: "/community",
    menuSecond: [],
  },
];
